var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlternateCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 33.001C15.0333 33.001 12.1332 32.1212 9.66645 30.473C7.19972 28.8248 5.27713 26.4821 4.14181 23.7412C3.0065 21.0003 2.70945 17.9843 3.28823 15.0746C3.86701 12.1649 5.29562 9.49217 7.3934 7.39438C9.49119 5.29659 12.1639 3.86798 15.0737 3.2892C17.9834 2.71043 20.9994 3.00748 23.7403 4.14279C26.4811 5.27811 28.8238 7.20069 30.472 9.66743C32.1203 12.1342 33 15.0343 33 18.001C32.9954 21.9778 31.4135 25.7904 28.6015 28.6024C25.7894 31.4145 21.9768 32.9963 18 33.001ZM18 4.87578C15.4041 4.87578 12.8665 5.64556 10.708 7.08778C8.54961 8.52999 6.86732 10.5799 5.8739 12.9782C4.88049 15.3765 4.62057 18.0155 5.127 20.5616C5.63344 23.1076 6.8835 25.4463 8.71909 27.2819C10.5547 29.1175 12.8934 30.3675 15.4394 30.874C17.9854 31.3804 20.6245 31.1205 23.0228 30.1271C25.4211 29.1337 27.471 27.4514 28.9132 25.293C30.3554 23.1345 31.1252 20.5969 31.1252 18.001C31.1213 14.5212 29.7372 11.185 27.2766 8.72441C24.816 6.26381 21.4798 4.8797 18 4.87573V4.87578ZM24.5832 14.4001L23.2578 13.0841L16.0393 20.2853L12.7387 17.0112L11.4165 18.3306L16.0426 22.9174L24.5832 14.4001Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlternateCheckmark);
export default __webpack_public_path__ + "static/media/alternate-checkmark.8b275b6096dc0e8471f9fed1275e3e72.svg";
export { ForwardRef as ReactComponent };